import api from '../config/api';
import { Card, CardListResponse, CardFilters } from '../types';

export const cardService = {
  list: async (filters: CardFilters = {}): Promise<CardListResponse> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.per_page) params.set('per_page', String(filters.per_page));
    if (filters.search) params.set('search', filters.search);
    if (filters.game_id) params.set('game_id', String(filters.game_id));
    if (filters.rarity) params.set('rarity', filters.rarity);
    if (filters.condition) params.set('condition', filters.condition);
    if (filters.is_foil !== undefined) params.set('is_foil', String(filters.is_foil));
    if (filters.value_op) params.set('value_op', filters.value_op);
    if (filters.value_amount !== undefined) params.set('value_amount', String(filters.value_amount));
    if (filters.sort_by) params.set('sort_by', filters.sort_by);
    if (filters.sort_dir) params.set('sort_dir', filters.sort_dir);
    const res = await api.get(`/api/cards?${params.toString()}`);
    return res.data;
  },

  getById: async (id: number): Promise<Card> => {
    const res = await api.get(`/api/cards/${id}`);
    return res.data;
  },

  create: async (data: Partial<Card>): Promise<Card> => {
    const res = await api.post('/api/cards', data);
    return res.data;
  },

  update: async (id: number, data: Partial<Card>): Promise<Card> => {
    const res = await api.put(`/api/cards/${id}`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/cards/${id}`);
  },

  uploadImage: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await api.post('/api/images/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data.url;
  },
};
